import {useSelector} from "react-redux";

export function ManagePolicyController() {

  const policyInputRequirementsPEV = useSelector((rootState) => rootState.policyInputRequirements.policyInputRequirements)
  const sisenseDataSources = policyInputRequirementsPEV.value?.data?.sisenseDataSources?.systemResources;
  const userGroups = policyInputRequirementsPEV.value?.data?.publishedUserGroups?.data;
  const createPolicyPEV = useSelector((rootState) => rootState.createPolicy.createPolicy)
  const editPolicyPEV = useSelector((rootState) => rootState.editPolicy.editPolicy)
  var policyNames = policyInputRequirementsPEV.value?.data?.policyNames?.policyNames;
  const policy = policyInputRequirementsPEV.value?.data?.policy

  let userGroupOptions = [];

  setUserGroupOptions();
  setPolicyNames();

  function setUserGroupOptions() {
    userGroups?.forEach((userGroup) => {
      userGroupOptions.push({
        key: userGroup.id,
        label: (
          <>
            <span className="dropdown-name">{userGroup.name}</span>
          </>
        ),
        value: userGroup.name,
      });
    });
  }

  function setPolicyNames() {
    if (policy !== null && policyNames !== undefined) {
      policyNames = policyNames.filter(policyName => policyName!==policy.name);
    }
  }

  return {
    userGroups,
    userGroupOptions,
    sisenseDataSources,
    policyInputRequirementsPEV,
    createPolicyPEV,
    policyNames,
    editPolicyPEV,
    policy
  };
}
